"use client";

import { cn } from "@repo/ui/lib/utils";

import ErrorState from "@/features/home/components/HomePageWidget/SearchSmart/ErrorState";

type thirdPartiesIframeProps = {
  html?: string | null;
  testId?: string;
  /** Extra classes for the content wrapper, e.g. to contain/scroll oversized embed markup. */
  contentClassName?: string;
};

export const ThirdPartyIframe = ({ html, testId, contentClassName }: thirdPartiesIframeProps) => {
  if (!html) {
    return <ErrorState onRetry={() => globalThis.location.reload()} />;
  }

  return (
    <div className="m-0 rounded-lg bg-white p-0" data-testid={testId}>
      <div className={cn(contentClassName)} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
